import React, { Component } from 'react';
import Timeline from '@atlassiansox/schedule-timeline';
import { addMonths, startOfWeek, subMonths } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { OpsgenieLogo } from '@atlaskit/logo';
import { Box, xcss } from '@atlaskit/primitives';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import messages from '../../../common/messages';
import { createMockSchedules, type ScheduleItem } from '../../../common/mocks/schedules';
import { MiddleInlineIcon, PoweredBy, ScheduleHeader } from './styled';

type Props = {
	intl: IntlShape;
};

const startDate = startOfWeek(new Date(), { weekStartsOn: 1 });
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const interval = 2;
const intervalUnit = 'weeks';
const dateFormat = 'dd D/MM';

const scheduleStartDate = startOfWeek(subMonths(new Date(), 1), { weekStartsOn: 1 });
const scheduleTimezone = timezone;

const periodLength = 7;

type State = {
	mockSchedule: ScheduleItem[];
};

// eslint-disable-next-line jira/react/no-class-components
class ExampleScheduleComponent extends Component<Props, State> {
	state = {
		mockSchedule: [],
	};

	componentDidMount() {
		const mockSchedule = createMockSchedules(
			scheduleStartDate,
			addMonths(
				scheduleTimezone == null
					? new Date(scheduleStartDate)
					: utcToZonedTime(scheduleStartDate, scheduleTimezone),
				2,
			),
			{ days: periodLength },
			scheduleTimezone,
		);

		this.setState({ mockSchedule });
	}

	render() {
		const { formatMessage } = this.props.intl;

		return (
			<Box
				// eslint-disable-next-line jira/integration/enforce-data-testid-usage
				data-test-id="opsgenie-schedule.components.example-schedule-component.example-timeline"
				xcss={scheduleContainerStyles}
			>
				<ScheduleHeader>
					<Box xcss={scheduleTitleStyles}>
						{formatMessage(messages.opsgenieScheduleExampleScheduleTitle)}
					</Box>
					<PoweredBy>
						{formatMessage(messages.opsgenieScheduleExampleSchedulePoweredBy)}
						<MiddleInlineIcon>
							<OpsgenieLogo label="" size="small" />
						</MiddleInlineIcon>
					</PoweredBy>
				</ScheduleHeader>
				<Timeline
					{...{
						startDate,
						timezone,
						interval,
						intervalUnit,
						dateFormat,
						scheduleStartDate,
					}}
					locale={this.props.intl.locale}
					currentDate={new Date().toISOString()}
					rotations={[
						{
							name: 'On Call',
							periods: this.state.mockSchedule,
						},
					]}
				/>
			</Box>
		);
	}
}

const scheduleContainerStyles = xcss({
	borderRadius: 'space.025',
	backgroundColor: 'elevation.surface.raised',
	boxShadow: 'elevation.shadow.raised',
	padding: 'space.200',
	marginBottom: 'space.300',
	overflow: 'auto',
	minWidth: '500px',
});

const scheduleTitleStyles = xcss({
	color: 'color.text',
	fontSize: 'font.body',
	fontWeight: 600,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '248px',
});

export default injectIntl(ExampleScheduleComponent);
